var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"APP-header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"APP-header-logo"},[_c('img',{staticClass:"img-responsive",attrs:{"src":(_vm.publicPath + "static/img/common/header_logo.png")}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }